import { FunctionComponent } from "react";
import { ReactComponent as JesprIcon } from "./jespr.svg";
import { ReactComponent as StravaIcon } from "./strava.svg";
import { ReactComponent as KomootIcon } from "./komoot.svg";
import { ReactComponent as TrainingPeaksIcon } from "./trainingPeaks.svg";
import { ReactComponent as RideWithGPSIcon } from "./ridewithgps.svg";

const PlatformIcon: FunctionComponent<{ id: string }> = ({ id }) => {
  switch (id) {
    case "STRAVA":
      return <StravaIcon />;
    case "KOMOOT":
      return <KomootIcon />;
    case "TRAINING_PEAKS":
      return <TrainingPeaksIcon height="40" />;
    case "RIDE_WITH_GPS":
      return <RideWithGPSIcon />;
    default:
      return <JesprIcon />;
  }
};

export default PlatformIcon;
